import {
  SET_OPERATION_PROPERTY,
  UPDATE_CONTACT_PROSPECT,
  UPDATE_OPERATION_DATA,
  SET_PATCH_OPERATION_FIELD,
  PROSPECT_TRANSFORM_PATCH_OPERATION
} from 'store/actions/operation';
import { dateToString, isoToDate, dateToISO } from 'helpers/date';
import { trimAndUppercase } from 'helpers/string';
import { setValueObjectByField, fetchFromObject } from 'helpers/object';
import { DOCUMENT_TYPES } from 'store/enums';
import validateSpanishId from '@/validators/rules/validateSpanishId';

export default {
  [SET_OPERATION_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
    // Check single field
    const lastIndex = field.lastIndexOf('.');
    const pathFielName = field.substring(0, lastIndex);
    const fieldName = field.substring(lastIndex + 1, field.length);
    // Condition for fields equal to some value
    // Equals postalCode field
    if (fieldName === 'postalCode') {
      setValueObjectByField(state, `${pathFielName}.provinceCode`, value.substring(0, 2));
    }
    // Equals documentId field
    if (fieldName === 'documentId') {
      const { type, valid } = validateSpanishId(value.toUpperCase());
      setValueObjectByField(
        state,
        `${pathFielName}.documentType`,
        valid ? DOCUMENT_TYPES[type.toUpperCase()] : 0
      );
    }
  },

  [UPDATE_OPERATION_DATA]: (state, operation) => {
    const {
      customerType,
      flux,
      prospect,
      signRequest,
      renovationPlate,
      operationOwner,
      marketPlaceOrderId
    } = operation;
    state.customerType = customerType;
    state.flux = flux;
    state.signRequest = signRequest;
    state.signRequest.delivery.date = dateToString(signRequest.delivery.date);
    state.renovationPlate = renovationPlate;
    state.operationOwner = operationOwner;
    state.marketPlaceOrderId = marketPlaceOrderId;
    if (prospect) {
      prospect.contact.forEach(element => {
        /* eslint-disable no-param-reassign */
        element.birthDate = dateToString(element.birthDate);
        if (element.driverLicenseIssuedDate)
          element.driverLicenseIssuedDate = dateToString(element.driverLicenseIssuedDate);
      });
      state.prospect = prospect;
    }
  },

  /* eslint complexity: ["error", 13] */
  // eslint-disable-next-line complexity
  [SET_PATCH_OPERATION_FIELD]: (state, { field, value }) => {
    const originalValue = fetchFromObject(state, field);
    const path = field.replace(/\./g, '/');
    const pathWithoutFielName = path.substring(0, path.lastIndexOf('/'));
    const fieldName = path.substring(path.lastIndexOf('/') + 1, path.length);
    if (state.patchOperation === undefined) state.patchOperation = {};
    if (
      (value && (originalValue !== value || fieldName === 'cityCode')) ||
      fieldName === 'renovationPlate'
    ) {
      if (fieldName === 'renovationPlate') {
        state.patchOperation[`/${fieldName}`] = value;
      } else {
        state.patchOperation[`/${path}`] =
          fieldName === 'bankAccount' ? trimAndUppercase(value) : value;
      }
      if (fieldName === 'postalCode' && value.length >= 2) {
        state.patchOperation[`/${pathWithoutFielName}/provinceCode`] = value.substring(0, 2);
      }
      if (fieldName === 'documentId') {
        const { type, valid } = validateSpanishId(value.toUpperCase());
        if (valid) {
          state.patchOperation[`/${pathWithoutFielName}/documentType`] =
            DOCUMENT_TYPES[type.toUpperCase()];
        }
      }
    } else {
      delete state.patchOperation[`/${path}`];
      if (fieldName === 'postalCode') {
        delete state.patchOperation[`/${pathWithoutFielName}/provinceCode`];
      } else if (fieldName === 'documentId') {
        delete state.patchOperation[`/${pathWithoutFielName}/documentType`];
      } else if (fieldName === 'renovationPlate') {
        delete state.patchOperation[`/${fieldName}`];
      }
    }
  },

  [PROSPECT_TRANSFORM_PATCH_OPERATION]: state => {
    const patchOperationToSend = [];
    if (state.patchOperation) {
      Object.keys(state.patchOperation).forEach(path => {
        let value = state.patchOperation[path];
        if (/birthDate|driverLicenseIssuedDate|requestedDeliveryDate/.test(path))
          value = dateToISO(value);
        patchOperationToSend.push({
          op: 'add',
          path,
          value
        });
      });
    }
    state.patchOperationToSend = patchOperationToSend;
  },

  [UPDATE_CONTACT_PROSPECT]: (state, { contact, pos }) => {
    const preField = `prospect.contact.${pos}`;
    const preFieldAddress = `${preField}.address`;
    const {
      name,
      lastname,
      lastname2,
      email,
      documentType,
      documentId,
      genre,
      mobile,
      birthDate,
      driverLicenseIssuedDate,
      jobType,
      address
    } = contact;
    const { postalCode, streetType, address1, cityCode, provinceCode } = address;
    setValueObjectByField(state, `${preField}.name`, name);
    setValueObjectByField(state, `${preField}.lastname`, lastname);
    setValueObjectByField(state, `${preField}.lastname2`, lastname2);
    setValueObjectByField(state, `${preField}.email`, email);
    setValueObjectByField(state, `${preField}.documentType`, Number(documentType));
    setValueObjectByField(state, `${preField}.documentId`, documentId);
    setValueObjectByField(state, `${preField}.genre`, genre);
    setValueObjectByField(state, `${preField}.mobile`, mobile);
    setValueObjectByField(state, `${preField}.birthDate`, isoToDate(birthDate));
    setValueObjectByField(
      state,
      `${preField}.driverLicenseIssuedDate`,
      isoToDate(driverLicenseIssuedDate)
    );
    setValueObjectByField(state, `${preField}.jobType`, jobType);
    setValueObjectByField(state, `${preFieldAddress}.postalCode`, postalCode);
    setValueObjectByField(state, `${preFieldAddress}.streetType`, streetType);
    setValueObjectByField(state, `${preFieldAddress}.address1`, address1);
    setValueObjectByField(state, `${preFieldAddress}.cityCode`, cityCode);
    setValueObjectByField(state, `${preFieldAddress}.provinceCode`, provinceCode);
  }
};
